/**
 * Agent is in format alpha.agent-1  => [prefix].[agentId]
 * Return agentId only
 */
export function encapsulateLongStrings (str) {
  let long = []
  let words = str.split(' ')
  let filtered = words.map(word => {
    if (word.length > 32) {
      long.push(word)
      return ''
    } else {
      return word
    }
  })
  return {
    string: filtered.join(' '),
    long: long,
    original: str
  }
}

/**
 * Capitalize first letter of a string
 */
export function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function interpolateText (text, value) {
  if (text.includes('{{ ip }}')) {
    text = text.replaceAll('{{ ip }}', value.ip)
  }
  if (text.includes('{{ip}}')) {
    text = text.replaceAll('{{ip }', value.ip)
  }
  if (text.includes('{{ host }}')) {
    text = text.replaceAll('{{ host }}', value.host)
  }
  if (text.includes('{{host}}')) {
    text = text.replaceAll('{{host}}', value.hsot)
  }
  if (text.includes('{{ user }}')) {
    text = text.replaceAll('{{ user }}', value.user)
  }
  if (text.includes('{{user}}')) {
    text = text.replaceAll('{{user}}', value.user)
  }
  if (text.includes('{{ city }}')) {
    text = text.replaceAll('{{ city }}', value.city)
  }
  if (text.includes('{{city}}')) {
    text = text.replaceAll('{{city}}', value.city)
  }
  if (text.includes('{{ country }}')) {
    text = text.replaceAll('{{ country }}', value.country)
  }
  if (text.includes('{{country}}')) {
    text = text.replaceAll('{{country}}', value.country)
  }
  return text
}



// WEBPACK FOOTER //
// ./src/utilities/string.helper.js